import { LocaleCode } from '../data/type/locale';

export const getLocaleFromPath = () => {
  const pathname = window.location.pathname;
  const matches = pathname.match(/\/[a-z]{2}-[a-z]{2}(\/)?/);

  return !!pathname && !!matches
    ? // Remove the slashes if there was a match.
      (matches[0].replace('/', '') as LocaleCode)
    : null;
};
